import type { AssessmentResultStore } from './interfaces'

export const getters = {
  isLoading: (state: AssessmentResultStore): AssessmentResultStore['loading'] => state.loading,
  isComprehension:  (state: AssessmentResultStore): AssessmentResultStore['comprehension'] => state.comprehension,
  getAssessmentId : (state: AssessmentResultStore): AssessmentResultStore['id'] => state.id,
  getQuestions: (state: AssessmentResultStore): AssessmentResultStore['questions'] => state.questions,
  getQuestionsTotal: (state: AssessmentResultStore): number => state.questions.length,
  getScore: (state: AssessmentResultStore): AssessmentResultStore['score'] => state.score,
  getVariant: (state: AssessmentResultStore): string => state.variant.toLowerCase(),
  getAssessmentUrls: (state: AssessmentResultStore): AssessmentResultStore['assessmentUrls'] => state.assessmentUrls,
}
